import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Navbar.module.css';

/**
 * Fixed top navigation bar with simple links.
 * All navigation uses useNavigate for testability consistency.
 */
function Navbar() {
  const navigate = useNavigate();

  function goHome() {
    navigate('/#about-annie');
    setTimeout(() => {
      const el = document.getElementById('about-annie');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  }

  function goJlpt() {
    navigate('/jlpt');
    window.scrollTo({ top: 0 });
  }

  function goToeic() {
    navigate('/toeic');
    window.scrollTo({ top: 0 });
  }

  function goContact() {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  return (
    <nav className={styles.nav} role="navigation" aria-label="Main navigation">
      {/* Logo */}
      <Link
        to="/"
        className={styles.logo}
        aria-label="Annie's Class home"
        onClick={() => window.scrollTo({ top: 0 })}
      >
        <div className={styles.logoIcon} aria-hidden="true">
          <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17" cy="10" r="6" fill="white" opacity="0.9" />
            <path d="M8 28c0-4.97 4.03-9 9-9s9 4.03 9 9" stroke="white" strokeWidth="2.2" strokeLinecap="round" fill="none" opacity="0.9" />
            <path d="M12 14 Q17 20 22 14" stroke="white" strokeWidth="1.5" fill="none" opacity="0.6" />
            <path d="M10 10 Q8 6 11 5" stroke="white" strokeWidth="1.2" fill="none" opacity="0.5" strokeLinecap="round" />
            <path d="M24 10 Q26 6 23 5" stroke="white" strokeWidth="1.2" fill="none" opacity="0.5" strokeLinecap="round" />
          </svg>
        </div>
        <span className={styles.logoText}>
          Annie's <span className={styles.logoAccent}>Class</span>
        </span>
      </Link>

      <ul className={styles.navList}>
        <li>
          <button className={styles.navLink} onClick={goHome}>
            Về Annie
          </button>
        </li>

        <li>
          <button className={styles.navLink} onClick={goJlpt}>
            JLPT
          </button>
        </li>

        <li>
          <button className={styles.navLink} onClick={goToeic}>
            TOEIC
          </button>
        </li>

        <li>
          <button className={styles.navCta} onClick={goContact}>
            Liên hệ
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
